import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
    it: {
        nav: { about: "Chi siamo", products: "Prodotti", why: "Perché noi", contacts: "Contatti", cta: "Richiedi il listino" },
        hero: {
            overline: "Selezione & distribuzione Ho.Re.Ca. — Milano",
            lines: ["Selezioniamo", "l'eccellenza", "per la tua cucina."],
            sub: "Azienda di distribuzione e selezione di prodotti alimentari per il settore Ho.Re.Ca.",
            ctaPrimary: "Scopri i prodotti",
            ctaSecondary: "Richiedi il listino",
        },
        manifesto: {
            overline: "Chi siamo",
            heading: "Il meglio per i nostri clienti Ho.Re.Ca.",
            chapters: [
                { num: "01", title: "La selezione", text: "Tartufo fresco bianco e nero, funghi stagionali, ittico di altissima qualità, carni grass-fed: ogni prodotto è scelto dal nostro team di esperti, grammatura per grammatura." },
                { num: "02", title: "Il partner", text: "Non un semplice fornitore: un atelier al fianco di Chef e professionisti F&B, con consulenza personalizzata e prodotti pronti all'uso che semplificano il lavoro in cucina." },
                { num: "03", title: "La consegna", text: "Milano A x B con furgoni a temperatura controllata, dal lunedì al sabato. Italia ed Estero con spedizioni A x C e via aerea. Freschezza intatta, sempre." },
            ],
            philosophy: {
                title: "La nostra filosofia",
                text: "Scegliamo produttori che condividono i nostri valori: sostenibilità, tracciabilità massima, benessere animale. Le nostre carni sono grass-fed, senza antibiotici né coloranti; gli animali vivono liberi all'aperto. Gli ittici selezionati sposano pesca sostenibile e rispetto dell'ambiente marino.",
            },
        },
        spotlight: {
            badge: "Disponibilità stagionale",
            overline: "Tartufi & Funghi",
            lines: ["Tartufo fresco", "bianco e nero."],
            text: "Proveniente da Italia ed Estero, selezionato dal nostro team di esperti in base alle grammature, adatte ai molteplici utilizzi. Funghi di varie tipologie, scelti in base alla disponibilità stagionale.",
            points: ["Bianco e nero pregiato", "Nero estivo di stagione", "Porcini e funghi di stagione"],
            more: "Come selezioniamo il tartufo",
            cta: "Richiedi disponibilità e listino",
        },
        catalog: {
            overline: "Catalogo",
            heading: "Categorie di prodotti",
            sub: "Prodotti selezionati da Midora Atelier Gastronomico per il settore Ho.Re.Ca.",
            groups: { tutti: "Tutti", freschi: "Freschi", ittico: "Ittico", "carni-salumi": "Carni & Salumi", formaggi: "Formaggi", dispensa: "Dispensa", fingerfood: "Finger food", "no-food": "No-food" },
            categories: {
                tartufi: { name: "Tartufi", desc: "Fresco bianco e nero, selezionato per grammatura" },
                funghi: { name: "Funghi", desc: "Porcini e varietà stagionali" },
                vegetali: { name: "Vegetali", desc: "Stagionali, lavorati e pronti all'uso" },
                ittico: { name: "Ittico", desc: "Conservato e congelato, già pulito, pronto all'uso" },
                carni: { name: "Carni", desc: "Grass-fed, senza antibiotici né coloranti" },
                salumi: { name: "Prosciutti e salumi", desc: "Selezione per i migliori ristoranti" },
                formaggi: { name: "Formaggi e latticini", desc: "Italiani ed esteri, affinati e freschi" },
                "pasta-riso": { name: "Pasta - Riso", desc: "Formati artigianali e risi selezionati" },
                condimenti: { name: "Condimenti", desc: "Oli EVO italiani ed esteri, aceti e salse" },
                panificati: { name: "Panificati dolci e salati", desc: "Basi e specialità da forno dolci e salate" },
                "gluten-free": { name: "Gluten free e vegan", desc: "Selezioni senza glutine e vegetali per ogni menu" },
                puree: { name: "Purée di frutta", desc: "Polpe e purée per cucina e pasticceria" },
                mondo: { name: "Etnici", desc: "Specialità etniche per menu contemporanei" },
                fingerfood: { name: "Finger food", desc: "Pronti all'uso, pensati per il servizio moderno" },
                "foie-gras": { name: "Foie gras", desc: "Selezioni d'eccellenza per l'alta cucina" },
                "no-food": { name: "No-food", desc: "Attrezzature e complementi per la cucina professionale" },
            },
        },
        why: {
            overline: "Perché scegliere noi",
            heading: "Servizio efficiente, qualità garantita",
            sub: "Servizi dedicati alla distribuzione Ho.Re.Ca., pensati per garantire qualità superiore e piena soddisfazione.",
            items: [
                { title: "Consegna veloce", text: "Milano A x B dal lunedì al venerdì 09:00–17:00 e il sabato 09:00–13:00. Spedizioni A x C in Italia e all'Estero." },
                { title: "Offerte personalizzate", text: "Prodotti pronti all'uso e di alta qualità che facilitano il lavoro in cucina e ottimizzano gli approvvigionamenti." },
                { title: "Supporto dedicato", text: "Un team sempre disponibile per garantire assistenza professionale e risposte rapide alle tue richieste." },
                { title: "Partner selezionati", text: "Collaboriamo solo con produttori italiani ed esteri di fiducia, per qualità e continuità nel servizio." },
            ],
        },
        certs: {
            heading: "Qualità garantita",
            sub: "Alcune delle certificazioni che possiedono i nostri fornitori con i relativi prodotti",
            items: [
                { label: "IFS FOOD", text: "Standard internazionale riconosciuto GFSI che certifica sicurezza, qualità, legalità e autenticità di prodotti e processi alimentari." },
                { label: "DOP", text: "Denominazione di Origine Protetta: garantisce qualità e tracciabilità degli ingredienti." },
                { label: "EU ORGANIC", text: "Alimenti conformi alle normative europee, prodotti senza l'utilizzo di pesticidi." },
            ],
        },
        contact: {
            overline: "Contatti",
            heading: "Richiedi il listino prezzi",
            sub: "Riservato ad attività con Partita IVA: ristoranti, hotel, catering e negozi.",
            business: "Ragione sociale",
            type: "Tipo di attività",
            types: { ristorante: "Ristorante", catering: "Catering", hotel: "Hotel", negozio: "Negozio", altro: "Altro" },
            vat: "Partita IVA",
            email: "Email",
            phone: "Telefono (opzionale)",
            message: "Messaggio (opzionale)",
            submit: "Invia richiesta",
            sending: "Invio in corso…",
            success: "Richiesta inviata! Ti risponderemo al più presto.",
            error: "Errore nell'invio. Riprova o contattaci direttamente.",
            invalid: "Controlla i campi obbligatori e riprova.",
            service: "Customer Service",
            warehouse: "Magazzino",
            city: "Milano — Lambrate",
            hours: "Lun–Ven 09:00–17:00 · Sab 09:00–13:00",
            whatsapp: "Scrivici su WhatsApp",
            maps: "Dove ci troviamo",
            deliveryTitle: "Consegna veloce",
            deliveryText: "Consegniamo a Milano (A x B) con i nostri furgoni a temperatura controllata e in tutta Italia (A x C) e all'Estero con spedizione aerea.",
            privacyLabel: "Ho letto e accetto l'informativa privacy.",
            privacyError: "Devi accettare l'informativa privacy per inviare la richiesta.",
        },
        footer: {
            tagline: "Azienda di distribuzione e selezione di prodotti alimentari per il settore Ho.Re.Ca.",
            rights: "© 2026 Midora Atelier Gastronomico. Tutti i diritti riservati.",
        },
        cookie: {
            text: "Utilizziamo cookie tecnici e, previo tuo consenso, cookie di analisi per migliorare l'esperienza di navigazione.",
            accept: "Accetta",
            reject: "Solo necessari",
            policy: "Privacy & Cookie Policy",
        },
    },
    en: {
        nav: { about: "About us", products: "Products", why: "Why us", contacts: "Contacts", cta: "Request price list" },
        hero: {
            overline: "Ho.Re.Ca. selection & distribution — Milan",
            lines: ["We select", "excellence", "for your kitchen."],
            sub: "Distribution and selection of fine food products for the Ho.Re.Ca. sector.",
            ctaPrimary: "Explore products",
            ctaSecondary: "Request price list",
        },
        manifesto: {
            overline: "About us",
            heading: "The best for our Ho.Re.Ca. clients",
            chapters: [
                { num: "01", title: "The selection", text: "Fresh white and black truffle, seasonal mushrooms, top-quality seafood, grass-fed meats: every product is chosen by our team of experts, gram by gram." },
                { num: "02", title: "The partner", text: "Not just a supplier — an atelier beside chefs and F&B professionals, with tailored consulting and ready-to-use products that simplify kitchen work." },
                { num: "03", title: "The delivery", text: "Milan A-to-B with temperature-controlled vans, Monday to Saturday. Italy and abroad with A-to-C shipping and air freight. Freshness intact, always." },
            ],
            philosophy: {
                title: "Our philosophy",
                text: "We choose producers who share our values: sustainability, full traceability, animal welfare. Our meats are grass-fed, free of antibiotics and colourings; the animals live outdoors. Our seafood embraces sustainable fishing and respect for the marine environment.",
            },
        },
        spotlight: {
            badge: "Seasonal availability",
            overline: "Truffles & Mushrooms",
            lines: ["Fresh truffle,", "white & black."],
            text: "Sourced from Italy and abroad, selected by our team of experts by weight, suited to every use. Mushrooms of many varieties, chosen with the season.",
            points: ["Alba white and black truffle", "Summer black truffle", "Porcini & fresh seasonal mushrooms"],
            more: "How we select fresh truffles",
            cta: "Check availability & prices",
        },
        catalog: {
            overline: "Catalogue",
            heading: "Product categories",
            sub: "Selected by Midora Atelier Gastronomico for the Ho.Re.Ca. sector.",
            groups: { tutti: "All", freschi: "Fresh", ittico: "Seafood", "carni-salumi": "Meat & Cured", formaggi: "Cheeses", dispensa: "Pantry", fingerfood: "Finger food", "no-food": "No-food" },
            categories: {
                tartufi: { name: "Truffles", desc: "Fresh white & black, selected by weight" },
                funghi: { name: "Mushrooms", desc: "Porcini & seasonal varieties" },
                vegetali: { name: "Vegetables", desc: "Seasonal, prepared, ready to use" },
                ittico: { name: "Seafood", desc: "Preserved & frozen, cleaned, ready to use" },
                carni: { name: "Meats", desc: "Grass-fed, no antibiotics or colourings" },
                salumi: { name: "Hams & cured meats", desc: "A selection for the finest restaurants" },
                formaggi: { name: "Cheeses & dairy", desc: "Italian & international, aged and fresh" },
                "pasta-riso": { name: "Pasta - Rice", desc: "Artisan shapes and selected rices" },
                condimenti: { name: "Condiments", desc: "Italian & international EVO oils, vinegars and sauces" },
                panificati: { name: "Sweet & savoury bakery", desc: "Sweet and savoury bases and oven specialities" },
                "gluten-free": { name: "Gluten free & vegan", desc: "Gluten-free and plant-based selections for every menu" },
                puree: { name: "Fruit purées", desc: "Purées for kitchen and pastry" },
                mondo: { name: "Ethnic", desc: "Ethnic specialities for contemporary menus" },
                fingerfood: { name: "Finger food", desc: "Ready-to-use, built for modern service" },
                "foie-gras": { name: "Foie gras", desc: "Excellence for fine dining" },
                "no-food": { name: "No-food", desc: "Equipment and professional kitchen essentials" },
            },
        },
        why: {
            overline: "Why choose us",
            heading: "Efficient service, guaranteed quality",
            sub: "Ho.Re.Ca. distribution services designed for superior quality and full customer satisfaction.",
            items: [
                { title: "Fast delivery", text: "Milan A-to-B Monday to Friday 09:00–17:00 and Saturday 09:00–13:00. A-to-C shipping across Italy and abroad." },
                { title: "Tailored offers", text: "Ready-to-use, high-quality products that make kitchen work easier and streamline supplies." },
                { title: "Dedicated support", text: "A team always available, ensuring professional assistance and fast answers to your requests." },
                { title: "Selected partners", text: "We only work with trusted Italian and international producers, for quality and service continuity." },
            ],
        },
        certs: {
            heading: "Guaranteed quality",
            sub: "Some of the certifications held by our suppliers and their products",
            items: [
                { label: "IFS FOOD", text: "GFSI-recognised international standard certifying the safety, quality, legality and authenticity of food products and processes." },
                { label: "DOP", text: "Protected Designation of Origin: guaranteed quality and ingredient traceability." },
                { label: "EU ORGANIC", text: "Food compliant with European regulations, produced without pesticides." },
            ],
        },
        contact: {
            overline: "Contacts",
            heading: "Request the price list",
            sub: "Reserved for VAT-registered businesses: restaurants, hotels, catering and shops.",
            business: "Business name",
            type: "Business type",
            types: { ristorante: "Restaurant", catering: "Catering", hotel: "Hotel", negozio: "Shop", altro: "Other" },
            vat: "VAT number",
            email: "Email",
            phone: "Phone (optional)",
            message: "Message (optional)",
            submit: "Send request",
            sending: "Sending…",
            success: "Request sent! We'll get back to you shortly.",
            error: "Something went wrong. Try again or contact us directly.",
            invalid: "Please check the required fields and try again.",
            service: "Customer Service",
            warehouse: "Warehouse",
            city: "Milan — Lambrate",
            hours: "Mon–Fri 09:00–17:00 · Sat 09:00–13:00",
            whatsapp: "Chat on WhatsApp",
            maps: "Find us on the map",
            deliveryTitle: "Fast delivery",
            deliveryText: "We deliver in Milan (A-to-B) with temperature-controlled vans, across Italy (A-to-C) and abroad by air freight.",
            privacyLabel: "I have read and accept the privacy policy.",
            privacyError: "You must accept the privacy policy to send the request.",
        },
        footer: {
            tagline: "Distribution and selection of fine food products for the Ho.Re.Ca. sector.",
            rights: "© 2026 Midora Atelier Gastronomico. All rights reserved.",
        },
        cookie: {
            text: "We use technical cookies and, with your consent, analytics cookies to improve your browsing experience.",
            accept: "Accept",
            reject: "Only necessary",
            policy: "Privacy & Cookie Policy",
        },
    },
    es: {
        nav: { about: "Quiénes somos", products: "Productos", why: "Por qué nosotros", contacts: "Contactos", cta: "Pedir tarifa" },
        hero: {
            overline: "Selección y distribución Ho.Re.Ca. — Milán",
            lines: ["Seleccionamos", "la excelencia", "para tu cocina."],
            sub: "Empresa de distribución y selección de productos alimentarios para el sector Ho.Re.Ca.",
            ctaPrimary: "Descubre los productos",
            ctaSecondary: "Pedir la tarifa",
        },
        manifesto: {
            overline: "Quiénes somos",
            heading: "Lo mejor para nuestros clientes Ho.Re.Ca.",
            chapters: [
                { num: "01", title: "La selección", text: "Trufa fresca blanca y negra, setas de temporada, productos del mar de altísima calidad, carnes grass-fed: cada producto lo elige nuestro equipo de expertos, gramo a gramo." },
                { num: "02", title: "El partner", text: "No un simple proveedor: un atelier junto a chefs y profesionales F&B, con consultoría personalizada y productos listos para usar que simplifican el trabajo en cocina." },
                { num: "03", title: "La entrega", text: "Milán A x B con furgones de temperatura controlada, de lunes a sábado. Italia y el extranjero con envíos A x C y por vía aérea. Frescura intacta, siempre." },
            ],
            philosophy: {
                title: "Nuestra filosofía",
                text: "Elegimos productores que comparten nuestros valores: sostenibilidad, trazabilidad máxima y bienestar animal. Nuestras carnes son grass-fed, sin antibióticos ni colorantes; los animales viven libres al aire libre. Nuestros productos del mar apoyan la pesca sostenible y el respeto del ambiente marino.",
            },
        },
        spotlight: {
            badge: "Disponibilidad de temporada",
            overline: "Trufas y setas",
            lines: ["Trufa fresca", "blanca y negra."],
            text: "Procedente de Italia y del extranjero, seleccionada por nuestro equipo de expertos según los gramajes, adecuados a múltiples usos. Setas de varias tipologías, elegidas según la temporada.",
            points: ["Trufa blanca de Alba y negra pregiada", "Trufa negra de verano", "Porcini y setas frescas de temporada"],
            more: "Cómo seleccionamos la trufa",
            cta: "Consultar disponibilidad y tarifa",
        },
        catalog: {
            overline: "Catálogo",
            heading: "Categorías de productos",
            sub: "Productos seleccionados por Midora Atelier Gastronomico para el sector Ho.Re.Ca.",
            groups: { tutti: "Todos", freschi: "Frescos", ittico: "Mar", "carni-salumi": "Carnes y embutidos", formaggi: "Quesos", dispensa: "Despensa", fingerfood: "Finger food", "no-food": "No-food" },
            categories: {
                tartufi: { name: "Trufas", desc: "Fresca blanca y negra, seleccionada por gramaje" },
                funghi: { name: "Setas", desc: "Porcini y variedades de temporada" },
                vegetali: { name: "Vegetales", desc: "De temporada, elaborados y listos para usar" },
                ittico: { name: "Mar", desc: "Conservado y congelado, ya limpio, listo para usar" },
                carni: { name: "Carnes", desc: "Grass-fed, sin antibióticos ni colorantes" },
                salumi: { name: "Jamones y embutidos", desc: "Selección para los mejores restaurantes" },
                formaggi: { name: "Quesos y lácteos", desc: "Italianos e internacionales, curados y frescos" },
                "pasta-riso": { name: "Pasta - Arroz", desc: "Formatos artesanales y arroces seleccionados" },
                condimenti: { name: "Condimentos", desc: "Aceites EVO italianos y extranjeros, vinagres y salsas" },
                panificati: { name: "Panificados dulces y salados", desc: "Bases y especialidades de horno dulces y saladas" },
                "gluten-free": { name: "Sin gluten y vegan", desc: "Selecciones sin gluten y de origen vegetal para cada menú" },
                puree: { name: "Purés de fruta", desc: "Pulpas y purés para cocina y pastelería" },
                mondo: { name: "Étnicos", desc: "Especialidades étnicas para menús contemporáneos" },
                fingerfood: { name: "Finger food", desc: "Listos para usar, pensados para el servicio moderno" },
                "foie-gras": { name: "Foie gras", desc: "Selecciones de excelencia para la alta cocina" },
                "no-food": { name: "No-food", desc: "Equipamiento y complementos para la cocina profesional" },
            },
        },
        why: {
            overline: "Por qué elegirnos",
            heading: "Servicio eficiente, calidad garantizada",
            sub: "Servicios dedicados a la distribución Ho.Re.Ca., pensados para garantizar calidad superior y plena satisfacción.",
            items: [
                { title: "Entrega rápida", text: "Milán A x B de lunes a viernes 09:00–17:00 y sábado 09:00–13:00. Envíos A x C en Italia y al extranjero." },
                { title: "Ofertas personalizadas", text: "Productos listos para usar y de alta calidad que facilitan el trabajo en cocina y optimizan los suministros." },
                { title: "Soporte dedicado", text: "Un equipo siempre disponible para garantizar asistencia profesional y respuestas rápidas." },
                { title: "Partners seleccionados", text: "Colaboramos solo con productores italianos y extranjeros de confianza, para calidad y continuidad de servicio." },
            ],
        },
        certs: {
            heading: "Calidad garantizada",
            sub: "Algunas de las certificaciones de nuestros proveedores y sus productos",
            items: [
                { label: "IFS FOOD", text: "Norma internacional reconocida por GFSI que certifica la seguridad, calidad, legalidad y autenticidad de los productos y procesos alimentarios." },
                { label: "DOP", text: "Denominación de Origen Protegida: garantiza calidad y trazabilidad de los ingredientes." },
                { label: "EU ORGANIC", text: "Alimentos conformes a la normativa europea, producidos sin pesticidas." },
            ],
        },
        contact: {
            overline: "Contactos",
            heading: "Solicita la tarifa de precios",
            sub: "Reservado a actividades con número de IVA: restaurantes, hoteles, catering y tiendas.",
            business: "Razón social",
            type: "Tipo de actividad",
            types: { ristorante: "Restaurante", catering: "Catering", hotel: "Hotel", negozio: "Tienda", altro: "Otro" },
            vat: "Número de IVA",
            email: "Email",
            phone: "Teléfono (opcional)",
            message: "Mensaje (opcional)",
            submit: "Enviar solicitud",
            sending: "Enviando…",
            success: "¡Solicitud enviada! Te responderemos lo antes posible.",
            error: "Error al enviar. Inténtalo de nuevo o contáctanos directamente.",
            invalid: "Revisa los campos obligatorios e inténtalo de nuevo.",
            service: "Atención al cliente",
            warehouse: "Almacén",
            city: "Milán — Lambrate",
            hours: "Lun–Vie 09:00–17:00 · Sáb 09:00–13:00",
            whatsapp: "Escríbenos por WhatsApp",
            maps: "Dónde estamos",
            deliveryTitle: "Entrega rápida",
            deliveryText: "Entregamos en Milán (A x B) con furgones de temperatura controlada, en toda Italia (A x C) y al extranjero por vía aérea.",
            privacyLabel: "He leído y acepto la política de privacidad.",
            privacyError: "Debes aceptar la política de privacidad para enviar la solicitud.",
        },
        footer: {
            tagline: "Empresa de distribución y selección de productos alimentarios para el sector Ho.Re.Ca.",
            rights: "© 2026 Midora Atelier Gastronomico. Todos los derechos reservados.",
        },
        cookie: {
            text: "Utilizamos cookies técnicas y, con tu consentimiento, cookies de análisis para mejorar la experiencia de navegación.",
            accept: "Aceptar",
            reject: "Solo necesarias",
            policy: "Política de Privacidad y Cookies",
        },
    },
    ja: {
        nav: { about: "私たちについて", products: "商品", why: "選ばれる理由", contacts: "お問い合わせ", cta: "価格表を請求" },
        hero: {
            overline: "Ho.Re.Ca.向けセレクション＆流通 — ミラノ",
            lines: ["卓越した食材を", "厳選して", "あなたの厨房へ。"],
            sub: "Ho.Re.Ca.セクター向けに食品の流通とセレクションを行う会社です。",
            ctaPrimary: "商品を見る",
            ctaSecondary: "価格表を請求",
        },
        manifesto: {
            overline: "私たちについて",
            heading: "Ho.Re.Ca.のお客様に最高を",
            chapters: [
                { num: "01", title: "セレクション", text: "フレッシュの白・黒トリュフ、季節のきのこ、最高品質の水産物、グラスフェッド肉：すべての商品を専門チームがグラム単位で厳選しています。" },
                { num: "02", title: "パートナー", text: "単なる仕入れ先ではなく、シェフやF&Bプロフェッショナルに寄り添うアトリエ。オーダーメイドのコンサルティングと、厨房の作業を簡素化するすぐに使える商品を提供します。" },
                { num: "03", title: "デリバリー", text: "ミラノ市内はA x B、温度管理車両で月曜から土曜まで配送。イタリア全土と海外へはA x Cおよび航空便で。鮮度は常にそのままに。" },
            ],
            philosophy: {
                title: "私たちの哲学",
                text: "私たちは価値観を共有する生産者を選びます：サステナビリティ、完全なトレーサビリティ、動物福祉。肉はグラスフェッドで抗生物質・着色料不使用、動物は屋外で自由に育てられています。水産物は持続可能な漁業と海洋環境への配慮に基づいています。",
            },
        },
        spotlight: {
            badge: "季節の入荷",
            overline: "トリュフ＆きのこ",
            lines: ["フレッシュトリュフ、", "白と黒。"],
            text: "イタリア産・外国産を問わず、専門チームが多様な用途に適したグラム数で選別。きのこ類は季節の入荷に合わせて各種取り揃えています。",
            points: ["白・黒の上質トリュフ", "夏黒トリュフ（旬）", "ポルチーニと季節のきのこ"],
            more: "トリュフの選び方",
            cta: "入荷状況と価格表を請求",
        },
        catalog: {
            overline: "カタログ",
            heading: "商品カテゴリー",
            sub: "Midora Atelier GastronomicoがHo.Re.Ca.セクター向けに厳選した商品。",
            groups: { tutti: "すべて", freschi: "フレッシュ", ittico: "水産物", "carni-salumi": "肉・生ハム", formaggi: "チーズ", dispensa: "ストック", fingerfood: "フィンガーフード", "no-food": "ノンフード" },
            categories: {
                tartufi: { name: "トリュフ", desc: "フレッシュ白・黒、グラム数で選別" },
                funghi: { name: "きのこ", desc: "ポルチーニと季節の品種" },
                vegetali: { name: "野菜", desc: "旬のもの、加工済みですぐに使える" },
                ittico: { name: "水産物", desc: "保存・冷凍、下処理済みですぐに使える" },
                carni: { name: "肉", desc: "グラスフェッド、抗生物質・着色料不使用" },
                salumi: { name: "生ハム・サラミ", desc: "最高のレストランのためのセレクション" },
                formaggi: { name: "チーズ・乳製品", desc: "イタリア産・外国産、熟成とフレッシュ" },
                "pasta-riso": { name: "パスタ - 米", desc: "職人のパスタと厳選された米" },
                condimenti: { name: "調味料", desc: "イタリア産・外国産EXVオリーブオイル、酢、ソース" },
                panificati: { name: "パン製品（甘・塩）", desc: "甘い・塩味のベースとオーブン製品" },
                "gluten-free": { name: "グルテンフリー＆ヴィーガン", desc: "あらゆるメニューに対応するグルテンフリー・植物性セレクション" },
                puree: { name: "フルーツピューレ", desc: "厨房と製菓用のピューレ" },
                mondo: { name: "エスニック", desc: "現代的なメニューのためのエスニック特産品" },
                fingerfood: { name: "フィンガーフード", desc: "すぐに使える、モダンなサービス向け" },
                "foie-gras": { name: "フォアグラ", desc: "高級料理のための厳選品" },
                "no-food": { name: "ノンフード", desc: "プロの厨房のための機器と用品" },
            },
        },
        why: {
            overline: "選ばれる理由",
            heading: "効率的なサービス、保証された品質",
            sub: "Ho.Re.Ca.流通のためのサービス。最高の品質と完全な満足をお約束します。",
            items: [
                { title: "迅速な配送", text: "ミラノ市内 A x B：月〜金 09:00–17:00、土 09:00–13:00。イタリア全土と海外へ A x C 配送。" },
                { title: "オーダーメイドの提案", text: "すぐに使える高品質な商品で、厨房の作業を効率化し仕入れを最適化します。" },
                { title: "専任サポート", text: "常に対応可能なチーム。プロフェッショナルなサポートと迅速な回答をお約束します。" },
                { title: "厳選されたパートナー", text: "信頼できるイタリア・海外の生産者のみと提携。品質とサービスの継続性を保証します。" },
            ],
        },
        certs: {
            heading: "保証された品質",
            sub: "提携生産者とその商品が保有する認証の一部",
            items: [
                { label: "IFS FOOD", text: "GFSI認定の国際規格。食品の安全性、品質、適法性、真正性を認証します。" },
                { label: "DOP", text: "保護原産地呼称：品質と原材料のトレーサビリティを保証します。" },
                { label: "EU ORGANIC", text: "EU規則に準拠し、農薬を使用せず生産された食品。" },
            ],
        },
        contact: {
            overline: "お問い合わせ",
            heading: "価格表を請求する",
            sub: "VAT登録事業者様限定：レストラン、ホテル、ケータリング、ショップ。",
            business: "法人名",
            type: "事業タイプ",
            types: { ristorante: "レストラン", catering: "ケータリング", hotel: "ホテル", negozio: "ショップ", altro: "その他" },
            vat: "VAT番号（Partita IVA）",
            email: "メール",
            phone: "電話（任意）",
            message: "メッセージ（任意）",
            submit: "リクエストを送信",
            sending: "送信中…",
            success: "リクエストを送信しました！近日中にご連絡いたします。",
            error: "送信エラー。もう一度お試しいただくか、直接お問い合わせください。",
            invalid: "必須項目を確認してもう一度お試しください。",
            privacyLabel: "プライバシーポリシーを読み、同意します。",
            privacyError: "送信にはプライバシーポリシーへの同意が必要です。",
            service: "カスタマーサービス",
            warehouse: "倉庫",
            city: "ミラノ — ランブラーテ",
            hours: "月〜金 09:00–17:00 · 土 09:00–13:00",
            whatsapp: "WhatsAppで問い合わせ",
            maps: "地図で見る",
            deliveryTitle: "迅速な配送",
            deliveryText: "ミラノ市内（A x B）は温度管理車両で、イタリア全土（A x C）と海外へは航空便でお届けします。",
        },
        footer: {
            tagline: "Ho.Re.Ca.セクター向け食品の流通・セレクション会社。",
            rights: "© 2026 Midora Atelier Gastronomico. All rights reserved.",
        },
        cookie: {
            text: "技術的Cookieと、同意いただいた場合に限り分析Cookieを使用し、閲覧体験を向上させます。",
            accept: "同意する",
            reject: "必要なもののみ",
            policy: "プライバシー＆Cookieポリシー",
        },
    },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        const q = new URLSearchParams(window.location.search).get("lang");
        if (["it", "en", "es", "ja"].includes(q)) return q;
        return localStorage.getItem("midora-lang") || "it";
    });

    useEffect(() => {
        localStorage.setItem("midora-lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (path) => {
        const value = path.split(".").reduce((obj, key) => (obj ? obj[key] : undefined), translations[lang]);
        return value === undefined ? path : value;
    };

    return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);

export const headingAccents = {
    it: { manifesto: "meglio", catalog: "prodotti", why: "qualità garantita", contact: "listino prezzi" },
    en: { manifesto: "best", catalog: "categories", why: "guaranteed quality", contact: "price list" },
    es: { manifesto: "mejor", catalog: "productos", why: "calidad garantizada", contact: "tarifa de precios" },
    ja: { manifesto: "最高", catalog: "カテゴリー", why: "保証された品質", contact: "価格表" },
};
